module.exports = __webpack_public_path__ + "static/media/stearns.5650ceaa.png";